import React, { FunctionComponent } from "react";
import { Switch, Route, withRouter, RouteComponentProps } from "react-router";
import { Roles } from "./Roles";

const RoleManagementRoutes: FunctionComponent<RouteComponentProps> = ({
  match: { url },
}) => (
  <Switch>
    <Route exact path={`${url}/`} render={() => <Roles />} />
  </Switch>
);

export const RoleManagement = withRouter(RoleManagementRoutes);
